/*
 * Public API Surface of ngx-page-scroll
 */

export { NgxPageScrollModule } from './lib/ngx-page-scroll.module';

export { NgxPageScrollDirective } from './lib/ngx-page-scroll.directive';
